module.exports = __webpack_public_path__ + "media/images/real-civis-00765f798cb82706429819e10317046c.png";